import React, { useRef, useEffect, useState } from 'react';
import { alpha } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Badge from '@mui/material/Badge';
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Container from '@mui/material/Container';
import { createTheme } from "@mui/material";
import { CSVLink, CSVDownload } from "react-csv";
import axios from 'axios'
import LinearProgress from '@mui/material/LinearProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

const drawerWidth = 300;

const materialTheme = createTheme(({
    // set default for now
  }));
const useStyles = makeStyles((theme) => ({

    appBar: {
        [theme.breakpoints.up('sm')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
        },
    },
    menuButton: {
        marginRight: theme.spacing(2),
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
    csvInput: {
        display: 'none',
      },
    csvDownloadBtn:{
        display: 'none',
    },  
    bottonSpacing:{
        '& > *': {
            margin: theme.spacing(1),
          },
    },
    leftLabel:{
        paddingLeft:'1rem',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      },
      rightLabel:{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }

}));

const BootstrapInput = withStyles((theme) => ({
    input: {
      borderRadius: 4,
      position: 'relative',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #ced4da',
      fontSize: 16,
      padding: '10px 26px 10px 12px',
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      // Use the system font instead of the default Roboto font.
    },
  }))(InputBase);

const filter = createFilterOptions();

export default function TransferStocks(props) {
    const classes = useStyles();
    const downloadCsvTemplateRef = useRef()
    const selectFileElement = useRef()
    const downloadCsvTemplateWithProductRef = useRef()

    const [isLoading,setIsLoading] = useState(true)
    const [isDownloadingProducts,setIsDownloadingProducts] = useState(false)
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading,setIsUploading] = useState(false)
    const [uploadingMessage,setUploadingMessage] = useState("")
    const [isUploadSuccess,setIsUploadSuccess] = useState(false)
    const [depots,setDepots] = useState([])
    const [selectedDepot,setSelectedDepot] = useState("")
    const [showConfirmationDialog,setShowConfirmationDialog] = useState(false)
    const [showMessageDialog,setShowMessageDialog] = useState(false)
    const [hasErrorGettingSubDepots,setHasErrorGettingSubDepots] = useState(false)
    const [message,setMessage] = useState("")
    const [isDownloadCsvTemplateWithProducts,setIsDownloadCsvTemplateWithProducts] = useState(false)
    
    const addStockCsvTemplate = [["Product Name", "Product Code*", "Quantity*","UOM*","Lot Number","Expiry Date"]];
    const addStockCsvTemplateWithProductsHeaders = [
      { label: "Product Name", key: "name" },
      { label: "Product Code", key: "code" },
      { label: "Quantity", key: "quantity" },
      { label: "UOM", key: "uom" },
      { label: "Lot Number", key: "lot_number" },
      { label: "Expiry Date", key: "expiry_date" },
    ];
    const [addStockCsvTemplateWithProducts,setAddStockCsvTemplateWithProducts] = useState([])


    const onCsvInputSelectChange = (event)=>{
        setShowConfirmationDialog(true)
    }
    
    const closeConfirmationDialogClickListener = ()=>{
        selectFileElement.current.value = null
        setShowConfirmationDialog(false)
    }
    
    useEffect(()=>{
        
        if(!isLoading){
            return
        }
        getSubDepots()

    },[])

    useEffect(()=>{

      if(!isDownloadCsvTemplateWithProducts){
        return
      }

      console.log()
      downloadCsvTemplateWithProductRef.current.link.click()
      setIsDownloadCsvTemplateWithProducts(false)

    },[isDownloadCsvTemplateWithProducts])
    function getTotalProductCount(){

      const options = {
        method: 'POST',
        url: '/Products/getTotalProductCount.json'
      }
      axios(options)
      .then(res => {
         

        console.log(res)
        const isSuccess = res.data.response.is_success
       
        if(!isSuccess){
          setIsDownloadingProducts(false)
          setMessage(res.data.response.message)
          setShowMessageDialog(true)
          return;
          
        }

        const limit = 1;
        const productCount = res.data.response.product_count;
        const remainder = productCount % limit;
        const totalPage =  parseInt(productCount / limit) + (remainder > 0 ? 1 : 0)

        downloadProductForTransactiLiteCSV(1,totalPage,limit)
        //console.log("total page "+totalPage)
                // setDepots(res.data.response.SubDepots)
       
       
      }).catch(error => {

        setIsUploadSuccess(false)
        setMessage("Failed to upload. "+error.message)
        setShowMessageDialog(true)

      })

    }

    
    function downloadProductForTransactiLiteCSV(currentPage,totalPage,limit){


      if(currentPage  > totalPage){
       
        console.log(addStockCsvTemplateWithProducts)
        setIsDownloadCsvTemplateWithProducts(true)
        return;
      }

      const formData = new FormData();
      formData.append("page",currentPage)
      formData.append("limit",limit)

     
        const options = {
          method: 'POST',
          url: '/Products/downloadProductForTransactiLiteCSV.json',
          data:formData
        }
        axios(options)
        .then(res => {
           
          const isSuccess = res.data.response.is_success
          if(!isSuccess){
            setIsUploadSuccess(false)
            setMessage(res.data.response.message)
            setShowMessageDialog(true)
            return;

                
          }


          const addStockCsvTemplateWithProductsCopy = [...addStockCsvTemplateWithProducts] 
          res.data.response.products.forEach((product)=>{
            product.quantity = ""
            product.lot_number = ""
            product.expiry_date = ""
            
            addStockCsvTemplateWithProducts.push(product)
           
          })

          setAddStockCsvTemplateWithProducts(addStockCsvTemplateWithProductsCopy)
       

          currentPage++
          downloadProductForTransactiLiteCSV(currentPage,totalPage,limit)
         
         
        }).catch(error => {
  
          console.log(error)
          alert("Error encounter.")
  
        })
      
    

    }
    function uploadCSV(){
       
        const file = selectFileElement.current.files[0]
        const csvFormData = new FormData();
        // dict of all elements
       csvFormData.append("product_csv", file);
        csvFormData.append("sub_depot_company_id",selectedDepot.company_id);
       
        const options = {
            method: 'POST',
            url: '/TransactiLiteTransferStocks/transferStockViaCSV.json',
            data:csvFormData,
            onUploadProgress: function(progressEvent){
                const progress = parseInt((progressEvent.loaded / progressEvent.total)* 100)
                setUploadProgress(progress)
                if(progress >= 100){
                    setUploadingMessage("Transferring...")
                }
                console.log(progress)
              
            }
          }
          axios(options)

          .then(res => {
                setIsUploading(false)

              const isSuccess = res.data.response.is_success
              if(!isSuccess){
                setIsUploadSuccess(false)
                setMessage(res.data.response.message)
                setShowMessageDialog(true)
                return;

                
              }
              
              setIsUploadSuccess(true)
              setMessage(res.data.response.message)
              setShowMessageDialog(true)
          
         
                
          }).catch(error => {

           

            setIsUploadSuccess(false)
             setMessage("Failed to upload. "+error.message)
             setShowMessageDialog(true)
          })
    }
    function getSubDepots(){

        const options = {
            method: 'POST',
            url: '/TransactiLiteDepots/getSubDepots.json'
          }
          axios(options)
          .then(res => {
             
            setIsLoading(false)
            const isSuccess = res.data.response.is_success
            const message = res.data.response.message 

            if(!isSuccess){
              alert("error encounter")
              setMessage(message)
              setHasErrorGettingSubDepots(true)
  
              return;
            }
  
         
            setDepots(res.data.response.SubDepots)
            setHasErrorGettingSubDepots(false)
           
          }).catch(error => {
            
            setIsLoading(false)
            setHasErrorGettingSubDepots(true)

            alert("Error encounter.")
   
          })

    }
    function messageDialog(){
        return (
            <div>
                 <StyledEngineProvider injectFirst>
                     <ThemeProvider theme={materialTheme}>
                  <Dialog
                  fullWidth={true}
                    open={showMessageDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                  >
                    <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description" style={{color:isUploadSuccess ? "black":"red"}}>
                       {message}
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={()=>{setShowMessageDialog(false)}} color="primary">
                        Close
                      </Button>
                     
                    </DialogActions>
                  </Dialog>
                  </ThemeProvider>
                 </StyledEngineProvider>
            </div>
        );

    }
    function uploadProgressElement(){
        return (
            <div style={{padding:'1rem'}}> 
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={materialTheme}>
                    <Typography variant="h6" component="h2">
                    {uploadingMessage}
                    </Typography>
                  <LinearProgress variant="determinate" value={uploadProgress} />
                  </ThemeProvider>
                </StyledEngineProvider>
            </div>
        );
    }
    function confirmationModalDialog(){
        return (
            <React.Fragment>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                <Dialog
            
                open={showConfirmationDialog}
                aria-labelledby="responsive-dialog-title"
              >
                <DialogTitle id="responsive-dialog-title">{"Transfer products now?"}</DialogTitle>
              
                <DialogActions>
                  <Button autoFocus 
                  onClick={closeConfirmationDialogClickListener} 
                  color="primary">
                    Cancel
                  </Button>
                  <Button onClick={()=>{
                      setUploadingMessage("Uploading...")
                      setIsUploading(true)
                      uploadCSV()
                      setShowConfirmationDialog(false)
                      }} color="primary" autoFocus>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
              </ThemeProvider>
            </StyledEngineProvider>
          </React.Fragment>
        );
    }
    function mainLayout(){
        return(
            <React.Fragment>
                <Grid container >
                <Grid item xs={4}  sm={3}  md={3} lg={1} className={classes.leftLabel}>Select Depot</Grid>
                <Grid item xs={8} sm={9} md={9} lg={11} className={classes.rightLabel} >
                <Select
                labelId="demo-customized-select-label"
                id="demo-customized-select"
                value={selectedDepot}
                onChange={(event)=>{
                    const selectedValue = event.target.value
                    setSelectedDepot(selectedValue)
                }}
                input={<BootstrapInput />}
                >
                    <MenuItem value=""> <em>None</em></MenuItem>
                    {
                        depots.map((depot)=>{
                            return(
                                <MenuItem key={depot.company_id} value={depot}>{depot.name}</MenuItem>
                            )
                        })
                    }
                
                </Select>
                </Grid>

            </Grid>
          
            <Grid container spacing={1} className={classes.bottonSpacing}>
                  <CSVLink 
                        headers={addStockCsvTemplateWithProductsHeaders}
                        data={addStockCsvTemplateWithProducts} 
                        className={classes.csvDownloadBtn}
                        ref={downloadCsvTemplateWithProductRef}
                        filename={"add_stock_template_with_products.csv"}
                        />

                <Grid >
                    <Button variant="contained" color="secondary" style={{width:"100%"}} onClick={()=>{downloadCsvTemplateRef.current.link.click()}}>Download template</Button>
                    <CSVLink 
                        data={addStockCsvTemplate} 
                        className={classes.csvDownloadBtn}
                        ref={downloadCsvTemplateRef}
                        filename={"add_stock_template.csv"}
                        />
                </Grid>
                <Grid >
                    <Button variant="contained" color="secondary" onClick={()=>{
                        setIsDownloadingProducts(true)
                        setAddStockCsvTemplateWithProducts([])
                        getTotalProductCount()
                      
                      }}>Download template with products</Button>
                </Grid >
                <Grid >
                    <input
                        accept=".csv"
                        ref={selectFileElement}
                        className={classes.csvInput}
                        id="contained-button-file"
                        multiple
                        type="file"
                        onChange={onCsvInputSelectChange}
                    />
                    <label >
                        <Button 
                            
                            variant="contained" 
                            color="secondary" 
                            component="span"
                            onClick={()=>{
                                if(selectedDepot == null || selectedDepot == ""){
                                    setMessage("Select depot first.")
                                    setShowMessageDialog(true)
                                    return
                                }
                                selectFileElement.current.click()
                            }}
                            >
                            Select File
                        </Button>
                    </label>
                </Grid>

                
            </Grid>
            {confirmationModalDialog()}
            </React.Fragment>
        )
    }

    function getLayout(){

      if(isLoading){
        return(uploadProgressElement())

      }else if(hasErrorGettingSubDepots){
       
        return(
          <Grid container style={{textAlign:'center'}}> 
          <Typography variant="h6" style={{width:'100%'}}>{message}</Typography>
          </Grid>
        )
      }else if(!isLoading && !hasErrorGettingSubDepots){
          return(mainLayout())
      }
    }
    return (
        <div>
            <CssBaseline />
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={props.handleDrawerToggle}
                        className={classes.menuButton}
                        size="large">
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="subtitle1" noWrap>
                        Transfer Stocks
                </Typography>
                </Toolbar>
            </AppBar>
            <div style={{padding:'.25rem'}}/>
            <div className={classes.appBarSpacer}></div>
            
            {getLayout()}
            {messageDialog()}
         
        </div>
    );

}